<template lang='pug'>
#moda-divergencia-localidade
    el-dialog(
        :visible.sync='show',
        :show-close="false"
        :close-on-click-modal='false'
    )
        h1 {{ $t('mensagens.territorio.sobreposicaoTerritorioParaguai.tituloModalSobreposicao') }}

        .subtitle-sobreposicao
          span(v-if="geometriaTerritorioSobreposto.length === 1") {{ $t('mensagens.territorio.sobreposicaoTerritorioParaguai.territorioSobreposto') }} {{territorioFormatado.codigoLyra}} {{territorioFormatado.nomeTerritorio}}
          span(v-else) {{ $t('mensagens.territorio.sobreposicaoTerritorioParaguai.territoriosSobrepostos') }}
            ul.mt-3
              li(v-for="item in territorioFormatado" :key="item.nomeTerritorio") {{item.codigoLyra}} {{ item.nomeTerritorio }}
            span {{ $t('mensagens.territorio.sobreposicaoTerritorioParaguai.reviseRegistro') }}

        .mapa-divergencia
          mapa.map-content(
            :mapLayersConfigs='layersMaps',
            :mapConfig='mapConfig',
            :idMapa='"mapaSobreposicaoTerritorio"',
            :height='"550px"',
            :deslocarPopup='true',
            :menuMaior='true'
            ref='mapa'
          )

        .moda-divergencia-localidade__footer(slot='footer')
            .buttons
                el-button(
                    type='default',
                    @click='$emit("voltar")'
                )
                    | {{ $t('mensagens.comuns.voltar') }}
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Mapa from '@/components/MapaLeaflet';
import { getEstiloGeometria } from '@/utils/mapa/mapa.estilos';

export default {
  name: 'ModalSobreposicaoTerritorioParaguai',
  emits: ['close'],
  components: {Mapa},
  props: {
      show: {
          type: Boolean,
          required: true
      },
      geometriaTerritorioSobreposto: {
          type: Array,
          required: true
      },
      geometriaTerritorio: {
          type: Object,
          required: true
      }
  },
  data() {
    return {
      mapConfig: {
        controls: {
          zoomControl: true,
          camadasControl: false,
          popupControl: false,
          drawControl: false,
          fullscreen: true,
          buscarCarControl: false
        },
        inspecionar: false,
        dontZoomIn: true,
        fitBounds: true
      },
      layersMaps: []
    };
  },
  computed: {
      ...mapGetters(['territoryTableData']),
      territorioFormatado() {
        if (this.geometriaTerritorioSobreposto.length === 1) {
          return this.geometriaTerritorioSobreposto[0];
        } else {
          return this.geometriaTerritorioSobreposto;
        }
      }
  },
  mounted() {
    this.mostrarTerritorioNoMapa(this.geometriaTerritorioSobreposto);
  },
  methods: {
    ...mapActions([
        'removeTerritoryTableData'
    ]),
    deleteTerritory(index) {
        if (this.territoryTableData[index].type === 'UPLOAD') {
            this.$emit(
                'delete-upload-file',
                this.territoryTableData[index].fileName
            );
        } else {
            this.$root.$emit(
                'remove-map-layer',
                this.territoryTableData[index].identificadorGeometria
            );
            this.removeTerritoryTableData(index);
        }
        this.$emit('click-delete-area');
    },
    mostrarTerritorioNoMapa(geometria) {
      this.layersMaps = [];

      if (this.geometriaTerritorio && this.geometriaTerritorio.coordinates) {
        const layerTerritorioFundo = {
          style: getEstiloGeometria('area'),
          name: this.geometriaTerritorio.nomeTerritorio || 'Território Principal',
          geoJson: {
            type: this.geometriaTerritorio.type,
            coordinates: this.geometriaTerritorio.coordinates
          },
          featureGroup: true
        };
        this.layersMaps.push(layerTerritorioFundo);
      }

      geometria.forEach(territorio => {
        if (territorio.geometriaSobreposicao) {
          const { coordinates, type } = territorio.geometriaSobreposicao;
          if (coordinates && type) {
            const layerTerritorioSobreposto = {
              style: getEstiloGeometria('restricao'),
              name: territorio.nomeTerritorio || 'Território Sobreposto',
              geoJson: {
                type,
                coordinates
              },
              featureGroup: true,
              tooltip: territorio.nomeTerritorio || 'Território Sobreposto'
            };
            this.layersMaps.push(layerTerritorioSobreposto);
          }
        }
      });
    }
  }
};
</script>

<style lang='scss'>
#moda-divergencia-localidade {

    .el-dialog {
        width: 70% !important;
    }

    .moda-divergencia-localidade__footer {
        display: contents;
    }

    .el-dialog__footer {
        .buttons {
            display: flex;
            justify-content: flex-end;
        }
    }

    .el-dialog__body {
        display: flex;
        flex-direction: column;
        align-items: center;
        word-break: break-word;
    }

    .icone {
        display: flex;
        justify-content: center;
        padding: 25px;
    }

    .icone::before {
        content: '';
        width: 60px;
        height: 60px;
        display: inline-block;
        background-color: var(--yellow);
    }

    .subtitle-sobreposicao {
      display: flex;
      margin: 5vh;
    }

    .mapa-divergencia {
      width: 90%;
      border-radius: 4px;
      overflow: hidden;
    }
}
</style>
